module.exports = __webpack_public_path__ + "img/infantil-juvenil.8fa0f057.png";